import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Header from "../../components/Header";
import PieChart from "../../components/PieChart";
import { tokens } from "../../theme";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const BOOK_COLORS = ["#22c55e", "#3b82f6", "#f59e0b", "#a855f7", "#ef4444"];

const Pie = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("adminToken");
      const response = await axios.get(`${BASE_URL}/api/admin/dashboard-stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const salesByBook = response.data?.salesByBook || [];
      const formatted = salesByBook.map((book, index) => {
        const title = book?._id || "Untitled";
        const sales = Number(book?.sales || 0);
        return {
          id: title,
          label: title.length > 22 ? `${title.slice(0, 22)}...` : title,
          value: sales,
          color: BOOK_COLORS[index % BOOK_COLORS.length],
        };
      });
      setData(formatted);
    } catch (error) {
      console.error("Failed to fetch pie chart data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Box m="20px">
      <Header title="Pie Chart" subtitle="Book sales share from real data" />
      <Box height="75vh">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress />
          </Box>
        ) : data.length > 0 ? (
          <PieChart data={data} />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography color={colors.grey[300]}>No pie chart data available yet.</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Pie;
